import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OrderProductService } from '../order-product.service';
import { OrderProduct } from '../order-product';
import { OrderProductComponent } from '../order-product/order-product.component';

@Component({
    selector: 'app-order-product-list',
    templateUrl: './order-product-list.component.html',
    styleUrls: ['./order-product-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OrderProductListComponent implements OnInit {
	feeTypes: any;
	feeFrequencies: any;
	constructor(
		private orderProductService: OrderProductService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = orderProductService.statuses;
		this.feeTypes = orderProductService.feeTypes;
		this.feeFrequencies = orderProductService.feeFrequencies;
	}



	// data
	orderProducts: any;
	orderProduct: OrderProduct;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'orderProductId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'listPrice', header: 'List Price', width: 'auto' },
		{ field: 'cashPaymentAdjustmentTarget', header: 'CP ADJ Target', width: 'auto' },
		{ field: 'salesTaxable', header: 'Sales Taxable', width: 'auto' },
		{ field: 'roomTaxable', header: 'Room Taxable', width: 'auto' },
		{ field: 'productCode ', header: 'Product Code', width: 'auto' },
		{ field: 'productGroup ', header: 'Product Group', width: 'auto' },
		{ field: 'applyToAllUnit', header: 'Apply To All Unit', width: 'auto' },
		{ field: 'feeUniquePerUnit ', header: 'Fee Unique Per Unit', width: 'auto' },
		{ field: 'feeType ', header: 'Fee Type', width: 'auto' },
		{ field: 'active ', header: 'Active', width: 'auto' },
		{ field: 'addToRate ', header: 'Add To Rate', width: 'auto' },
		{ field: 'feeFrequency ', header: 'Fee Frequency', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'name', order: 1 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.orderProductId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-orderProduct-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'name', order: 1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.orderProductService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.orderProducts = res.data.orderProducts;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.orderProducts = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(orderProduct: OrderProduct) {
		try {
			this.formLoading = true;
			this.orderProductService.update(orderProduct)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.orderProducts.map((orderProduct, i) => {
							if (orderProduct.orderProductId === res.data.orderProduct.orderProductId) {
								this.orderProducts[i] = res.data.orderProduct;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(orderProduct: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(orderProduct));

			this.formLoading = true;
			this.orderProductService.delete(orderProduct.orderProductId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.orderProducts.splice(this.orderProducts.indexOf(orderProduct), 1);
						this.recordTotal = this.orderProducts.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderProduct ' + orderProduct.orderProductId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderProduct ' + orderProduct.orderProductId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "50vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OrderProduct'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderProductComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOrderProductCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(orderProduct: OrderProduct) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "50vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			orderProduct: orderProduct,
			title: 'Edit OrderProduct'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderProductComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOrderProductCB(data);

				// close the dialogBox
				// dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOrderProductCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOrderProductCB(orderProduct: OrderProduct) {
		console.log('Adding OrderProduct: ' + JSON.stringify(orderProduct));
		// if we don't have a orderProducts array yet...
		if (!this.orderProducts) {
			this.orderProducts = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.orderProducts.unshift(orderProduct);

		// no idea what this is but it is required to update the array
		this.orderProducts = [...this.orderProducts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderProduct ' + orderProduct.orderProductId + ' Added', life: 3000 });
	}

	updateOrderProductCB(orderProduct: OrderProduct) {
		console.log('Updating OrderProduct: ' + JSON.stringify(orderProduct));
		let itemIndex = this.orderProducts.findIndex((item: any) => item.orderProductId === orderProduct.orderProductId);
		this.orderProducts[itemIndex] = orderProduct;

		// no idea what this is but it is required to update the array
		this.orderProducts = [...this.orderProducts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderProduct ' + orderProduct.orderProductId + ' Updated', life: 3000 });
	}

	deleteOrderProductCB(orderProduct: OrderProduct) {
		console.log('Removing OrderProduct: ' + orderProduct);
		this.orderProducts.splice(this.orderProducts.indexOf(orderProduct), 1);
		this.recordTotal = this.orderProducts.length;

		// no idea what this is but it is required to update the array
		this.orderProducts = [...this.orderProducts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderProduct ' + orderProduct.orderProductId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.orderProducts ? this.first === (this.orderProducts.length - this.rows) : true; }
	isFirstPage(): boolean { return this.orderProducts ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(orderProduct: any) {
		if (orderProduct?.status) {
			const status = this.statuses.find((e: any) => e.value == orderProduct.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getFeeTypesName(orderProduct: any) {
		if (orderProduct?.feeType) {
			const status = this.feeTypes.find((e: any) => e.value == orderProduct.feeType);
			return status.name;
		}
		else {
			return '';
		}
	}

	getFeeFrequencyName(orderProduct: any) {
		if (orderProduct?.feeFrequency) {
			const status = this.feeFrequencies.find((e: any) => e.value == orderProduct.feeFrequency);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
